import { useEffect } from 'react';
// This is the way we can import a webworker without messing with the stock webpack setup.
//  @ts-ignore
import worker from 'workerize-loader!../../../worker'; // eslint-disable-line import/no-webpack-loader-syntax
import { env } from '../../../App/config/env';
import { getCDNURI } from '../../../utils/getCDNURI';
import { findAllAssetsInSettings } from '../../whitelabeling/branding/utils/findAllAssetsInSettings';
import { COMMON_APP_ASSETS } from '../appAssets';

const instance = worker();

// Download the app assets
export const DownloadAppAssets = () => {
  useEffect(() => {
    const urls = [
      ...COMMON_APP_ASSETS.map(getCDNURI),
      // app specific assets (i.e. only relevant whitelabel assets)
      ...findAllAssetsInSettings(env.APP_ENV),
    ];

    // call the cacheURLs webworker function
    instance.cacheURLs(urls).then((count: number) => {
      // console.info(`${count} assets cached`);
    });
  }, []);

  return null;
};
